//use pure javascript es5 only or use compressor like https://es6console.com/
//js file should be implemented in media library- assets-we.cas.dgs.com/-/media/oticon/main/assets/click-dimension-form/click-dimension-form.js

var clickDimensionExternalForm = {
  className: '.component:not(.hcl-embed-form) form#clickdimensionsForm .responsiveRow',
  outerHtml: false,
  init: function init() {
    var _document$querySelect;
    this.createLabels();
    this.addCustomSelectClass();
    this.createDropdown();
    this.formValidation();
    (_document$querySelect = document.querySelector('.component:not(.hcl-embed-form) div.clickdform')) === null || _document$querySelect === void 0 || _document$querySelect.classList.add('inited');
    this.hideLoaderOverlay();
  },
  loadBackupMessage: function loadBackupMessage() {
    var _this = this;
    var formContainer = document.querySelector('div[pageid]');
    var dictionary = {
      AdblockError: {
        Error: 'Please turn off your adblock to access the form.'
      }
    };
    if ((formContainer === null || formContainer === void 0 ? void 0 : formContainer.children.length) <= 1 && !formContainer.querySelector('.adblock-detected')) {
      var errorMessageWrapper = document.createElement('div');
      var errorMessageInnerWrapper = document.createElement('div');
      var errorMessageText = document.createElement('p');
      window.DGS.Dictionary.getInstance().getTexts(dictionary, function () {
        errorMessageWrapper.classList.add('adblock-detected');
        errorMessageInnerWrapper.classList.add('video-spot-error-msg');
        errorMessageText.classList.add('video-spot-error-msg-desc');
        errorMessageText.innerText = dictionary.AdblockError.Error;
        errorMessageWrapper.appendChild(errorMessageInnerWrapper);
        errorMessageInnerWrapper.appendChild(errorMessageText);
        formContainer.appendChild(errorMessageWrapper);
        _this.hideLoaderOverlay();
      });
    }
  },
  createLabels: function createLabels() {
    document.querySelectorAll(this.className + ' input[type="text"], ' + this.className + ' textarea').forEach(function (item) {
      item.addEventListener('change', function (e) {
        e.currentTarget.setAttribute('empty-data', !e.currentTarget.value);
      });
      var parentElement = item.parentNode;
      var label = document.createElement('label');
      label.setAttribute('for', item.id);
      if (item.type === 'textarea') {
        label.innerText = item.value;
        item.innerText = '';
        item.value = '';
      } else {
        label.innerText = parentElement.parentNode.parentNode.querySelector('span').innerText;
      }
      item.setAttribute('empty-data', !item.value);
      parentElement.insertBefore(label, item.nextSibling);
    });
    document.querySelectorAll(this.className).forEach(function (item) {
      var isRadio = item.contains(item.querySelector('input[type="radio"]'));
      var isText = item.contains(item.querySelector('input[type="text"]'));
      var columns = item.querySelectorAll('.responsiveCell:not(.emptyCell)').length || 0;
      if (isRadio) {
        item.classList.add('radio-row');
      }
      if (isText) {
        item.classList.add('text-row');
      }
      if (columns) {
        item.classList.add('columns-' + columns);
      }
    });
    document.querySelectorAll(this.className + ' input[type="radio"]').forEach(function (item) {
      var parentElement = item.parentNode;
      var fakeRadio = document.createElement('span');
      parentElement.classList.add('radio-wrapper');
      fakeRadio.classList.add('fake-radio');
      item.id = item.name;
      parentElement.insertBefore(fakeRadio, item.nextSibling);
    });
    document.querySelectorAll(this.className + ' input[type="checkbox"]').forEach(function (item) {
      var parentElement = item.parentNode;
      var label = item.nextElementSibling;
      parentElement.classList.add('checkbox-wrapper');
      label.innerHTML = label.innerText;
    });
  },
  addCustomSelectClass: function addCustomSelectClass() {
    document.querySelectorAll(this.className).forEach(function (item) {
      var isSelect = item.contains(item.querySelector('select'));
      var isTextArea = item.contains(item.querySelector('textarea'));
      var questionContainer = item.contains(item.querySelector('.QuestionContainer .ui-stars-star'));
      if (isSelect) {
        item.classList.add('select-row');
      }
      if (isTextArea) {
        var textField = item.querySelector('textarea');
        item.classList.add('textarea');
      }
      if (questionContainer) {
        item.classList.add('question-row');
        item.querySelector('label').classList.add('question-label');
      }
    });
  },
  createDropdown: function createDropdown() {
    document.querySelectorAll(this.className + ' select').forEach(function (item) {
      var parentElement = item.parentNode;
      var customDropdown = document.createElement('div');
      var customDropdownWrapper = document.createElement('dl');
      var customDropdownHead = document.createElement('dt');
      var customDropdownButton = document.createElement('button');
      var customDropdownBody = document.createElement('dd');
      var customDropdownList = document.createElement('ul');
      customDropdown.classList.add('cd-custom-dropdown');
      customDropdownBody.classList.add('cd-custom-dropdown__list-wrapper');
      customDropdownList.classList.add('cd-custom-dropdown__list');
      customDropdownButton.classList.add('cd-custom-dropdown__button');
      customDropdownButton.setAttribute('type', 'button');
      customDropdownButton.innerText = parentElement.parentNode.parentNode.querySelector('span').innerText;
      item.parentNode.insertBefore(customDropdown, item.nextSibling);
      customDropdown.appendChild(customDropdownWrapper);
      customDropdownWrapper.appendChild(customDropdownHead);
      customDropdownHead.appendChild(customDropdownButton);
      customDropdownWrapper.appendChild(customDropdownBody);
      customDropdownBody.appendChild(customDropdownList);
      function closeDropdown() {
        customDropdown.classList.remove('is-open');
        customDropdownBody.style.maxHeight = null;
      }
      item.querySelectorAll('option:not([value="-1"])').forEach(function (option) {
        var customDropdownListItem = document.createElement('li');
        customDropdownListItem.classList.add('cd-custom-dropdown__list-item');
        customDropdownListItem.setAttribute('value', option.getAttribute('value'));
        customDropdownListItem.innerText = option.innerText;
        customDropdownList.appendChild(customDropdownListItem);
        customDropdownListItem.addEventListener('mousedown', function (e) {
          customDropdownButton.innerText = e.target.innerText;
          closeDropdown();
          item.value = option.getAttribute('value');
          item.dispatchEvent(new Event('change'));
        });
      });
      customDropdownButton.addEventListener('click', function (e) {
        if (customDropdown.classList.contains('is-open')) {
          closeDropdown();
        } else {
          var bounding = e.currentTarget.getBoundingClientRect();
          customDropdownBody.scrollHeight > window.innerHeight - bounding.bottom ? customDropdown.classList.add('static') : null;
          customDropdown.classList.add('is-open');
          customDropdownBody.style.maxHeight = customDropdownBody.scrollHeight + 'px';
        }
      });
      customDropdownButton.addEventListener('blur', function (e) {
        closeDropdown();
      });

      // fix for iOS Safari dropdown not closing
      if (/(iPad|iPhone|iPod)/g.test(window.navigator.userAgent) > 0) {
        customDropdownWrapper.addEventListener('mouseleave', function (e) {
          closeDropdown();
        });
      }
    });
  },
  createLoaderOverlay: function createLoaderOverlay() {
    var formContainer = document.querySelector("div[pageid]");
    var form = !!document.querySelector(this.className);
    if (typeof loc !== 'undefined' && formContainer && !form) {
      var addElement = function addElement(element, parent, className) {
        element.classList.add(className);
        parent.appendChild(element);
      };
      var elementClasses = ['formLoaderOverlay', 'loaderAnimated', 'spinner', 'bounce1', 'bounce2', 'bounce3'];
      var parentElement = formContainer.parentNode.parentNode;
      for (var i = 0; i < elementClasses.length; i += 1) {
        window[elementClasses[i]] = document.createElement('div');
      }
      addElement(formLoaderOverlay, parentElement, 'form-loader-overlay');
      addElement(loaderAnimated, formLoaderOverlay, 'loader-animated');
      addElement(spinner, loaderAnimated, 'spinner');
      addElement(bounce1, spinner, 'bounce1');
      addElement(bounce2, spinner, 'bounce2');
      addElement(bounce3, spinner, 'bounce3');
    }
  },
  hideLoaderOverlay: function hideLoaderOverlay() {
    var formLoaderOverlay = document.querySelector("div.form-loader-overlay");
    if (typeof loc !== 'undefined' && formLoaderOverlay) {
      formLoaderOverlay.style.display = "none";
    }
  },
  formValidation: function formValidation() {
    var btnSubmit = document.querySelector('.buttonContainer input#btnSubmit');
    var requiredFields = document.querySelectorAll(this.className + ' input[type="hidden"][req="true"]');
    function setVariables(element) {
      var parent = element.parentElement;
      var textInput = parent === null || parent === void 0 ? void 0 : parent.querySelector('input[type="text"]');
      var textarea = parent === null || parent === void 0 ? void 0 : parent.querySelector('textarea');
      var radioInput = parent === null || parent === void 0 ? void 0 : parent.querySelectorAll('input[type="radio"]');
      var checkboxInput = parent === null || parent === void 0 ? void 0 : parent.parentElement.querySelector('input[type="checkbox"]');
      var dropdown = parent === null || parent === void 0 ? void 0 : parent.querySelector('select');
      return [textInput, textarea, radioInput, checkboxInput, dropdown];
    }
    function textInputValidation(element) {
      if (element.value !== '') {
        element.parentElement.classList.remove('has-error');
      } else {
        element.parentElement.classList.add('has-error');
      }
    }
    function radioInputValidation(element) {
      if (!element.parentElement.parentElement.querySelector('input[type="radio"]:checked')) {
        element.parentElement.parentElement.classList.add('has-error');
      } else {
        element.parentElement.parentElement.classList.remove('has-error');
      }
    }
    function checkboxValidation(element) {
      if (!element.checked) {
        element.parentElement.parentElement.parentElement.classList.add('has-error');
      } else {
        element.parentElement.parentElement.parentElement.classList.remove('has-error');
      }
    }
    function dropdownValidation(element) {
      if (element.value === '-1') {
        element.parentElement.classList.add('has-error');
      } else {
        element.parentElement.classList.remove('has-error');
      }
    }
    function trackFormSubmit() {
      var clinicName = new URLSearchParams(window.location.search).get("place");
      var formName = window.location.pathname;
      function isDataLayer() {
        return window.DGS && window.DGS.GTMTracking && window.DGS.GTMTracking.getDataLayer();
      }
      function createFormSubmitPayload(formName) {
        var clinicName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        var eventData = {
          event: 'genericGAEvent',
          event_category: "form_submitted",
          event_action: formName,
          event_label: clinicName,
          event_value: ''
        };
        if (isDataLayer) {
          window.DGS.GTMTracking.getDataLayer().push(eventData);
        } else {
          console.log("DGS GTM not implemented. Debug data: ".concat(eventData));
        }
      }
      if (clinicName) {
        createFormSubmitPayload(formName, clinicName);
      } else {
        createFormSubmitPayload(formName);
      }
    }
    requiredFields.forEach(function (item) {
      var requiredMessage = item.getAttribute('requrederrormsg');
      item.previousElementSibling.innerHTML = '<div>' + requiredMessage + '</div>';
      if (setVariables(item)[0]) {
        setVariables(item)[0].addEventListener('input', function () {
          textInputValidation(setVariables(item)[0]);
        });
      }
      if (setVariables(item)[1]) {
        setVariables(item)[1].addEventListener('input', function () {
          textInputValidation(setVariables(item)[1]);
        });
      }
      if (setVariables(item)[2]) {
        setVariables(item)[2].forEach(function (input) {
          input.addEventListener('change', function () {
            setVariables(item)[2].forEach(function (innerInput) {
              innerInput.parentElement.parentElement.classList.add('has-error');
            });
            input.parentElement.parentElement.classList.remove('has-error');
          });
        });
      }
      if (setVariables(item)[3]) {
        setVariables(item)[3].addEventListener('change', function () {
          checkboxValidation(setVariables(item)[3]);
        });
      }
      if (setVariables(item)[4]) {
        setVariables(item)[4].addEventListener('change', function () {
          dropdownValidation(setVariables(item)[4]);
        });
      }
    });
    if (btnSubmit) {
      btnSubmit.addEventListener('click', function (e) {
        if (requiredFields) {
          requiredFields.forEach(function (item) {
            if (setVariables(item)[0]) {
              textInputValidation(setVariables(item)[0]);
            }
            if (setVariables(item)[1]) {
              textInputValidation(setVariables(item)[1]);
            }
            if (setVariables(item)[2]) {
              setVariables(item)[2].forEach(function (input) {
                radioInputValidation(input);
              });
            }
            if (setVariables(item)[3]) {
              checkboxValidation(setVariables(item)[3]);
            }
            if (setVariables(item)[4]) {
              dropdownValidation(setVariables(item)[4]);
            }
          });
          var errorFields = document.querySelectorAll('form#clickdimensionsForm .responsiveRow .has-error');
          if (errorFields.length > 0) {
            var _errorFields$;
            (_errorFields$ = errorFields[0]) === null || _errorFields$ === void 0 || _errorFields$.scrollIntoView();
          } else {
            trackFormSubmit();
          }
        } else {
          trackFormSubmit();
        }
      });
    }
  }
};
clickDimensionExternalForm.createLoaderOverlay();
window.onload = function () {
  clickDimensionExternalForm.loadBackupMessage();
  if (document.querySelector('div[pageid]')) {
    clickDimensionExternalForm.init();
  }
};
var observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (!mutation.addedNodes) return;
    if (mutation.addedNodes.length === 0) {
      clickDimensionExternalForm.loadBackupMessage();
      observer.disconnect();
    }
    for (var i = 0; i < mutation.addedNodes.length; i++) {
      var node = mutation.addedNodes[i];
      if (node.tagName === 'DIV') {
        if (node.classList === 'clickdform mainDiv') {
          clickDimensionExternalForm.init();
          observer.disconnect();
        }
      }
    }
  });
});
observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: false,
  characterData: false
});